import { getCasePropSelector } from '../utils/case-prop-selector'
import { selectSedationLevel } from './sedation-level'

/** @type {(caseData: CaseData) => boolean} */
export const selectCalculateDrugWaste = getCasePropSelector(
  'calculateDrugWaste',
  true
)

// Vitals tracking can only be disabled for local cases, so we ignore vitalsTrackingEnabled
// for non-local cases in case it's not set correctly.
const vitalsTrackingEnabledRaw = getCasePropSelector(
  'vitalsTrackingEnabled',
  true
)

/** @type {CaseSelector<boolean>} */
export const selectVitalsTrackingEnabled = caseData => {
  const sedationLevel = selectSedationLevel(caseData)
  if (sedationLevel !== 'Local') return true
  return vitalsTrackingEnabledRaw(caseData)
}

/** @type {CaseSelector<boolean>} */
export const selectAirwayEnabled = getCasePropSelector('airwayEnabled', false)

/** @type {CaseSelector<boolean>} */
export const selectIVEnabled = getCasePropSelector('ivEnabled', false)
